var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 23.7",
    style: {
      enableBackground: "new 0 0 24 23.7"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 23.704,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2;}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_32x32_Editing_EditOn",
    transform: "translate(-181 -4512.796)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7191",
    transform: "translate(39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    className: "st0",
    d: "M155,4535h11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_576_2",
    className: "st0",
    d: "M156,4518l4,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_575_2",
    className: "st0",
    d: "M147.5,4535h-4c-0.3,0-0.5-0.2-0.5-0.5v-4l16.3-16.3c0.4-0.4,1-0.4,1.4,0l3.1,3.1 c0.4,0.4,0.4,1,0,1.4L147.5,4535z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    className: "st1",
    cx: 152,
    cy: 4535,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilW);
export default __webpack_public_path__ + "static/media/pencil_w.151d5716134662c5d36eaae919aac50f.svg";
export { ForwardRef as ReactComponent };